import { render, staticRenderFns } from "./customInput.vue?vue&type=template&id=6f53f198&"
import script from "./customInput.vue?vue&type=script&lang=ts&"
export * from "./customInput.vue?vue&type=script&lang=ts&"
import style0 from "./customInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports